"use client";

import { c as _c } from "react/compiler-runtime";
import { useDocumentActionsContext } from "@hooks/pages/use-document-actions";
import React, { FC, PropsWithChildren } from "react";
export const DocumentAside: FC<PropsWithChildren> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    asideNode
  } = useDocumentActionsContext().state ?? {};
  if (!asideNode) {
    return null;
  }
  let t1;
  if ($[0] !== asideNode || $[1] !== children) {
    t1 = <aside className="lg:sticky lg:w-1/5">{asideNode}{children}</aside>;
    $[0] = asideNode;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};